import defaultAvatar from '../assets/default-avatar.jpg';
import defaultBoyAvatar from '../assets/boy.png';
import defaultGirlAvatar from '../assets/girl.png';

export {
    defaultAvatar,
    defaultBoyAvatar,
    defaultGirlAvatar,
};

export default {
    methods: {
        handleRefAvatarError(avatarRef = 'avatar', gender = undefined) {
            const ref = typeof avatarRef === 'string' ? avatarRef : 'avatar';
            if (this.$refs[ref]) {
                let ele = this.$refs[ref];
                ele = Array.isArray(ele) ? ele[0] : ele;
                // ChangWei
                // eslint-disable-next-line no-console
                console.warn(`Avatar Image Ref '${ref}' Error: ${ele.src}`);
                if (gender === '男' || gender === '女') {
                    ele.src = gender === '男' ? defaultBoyAvatar : defaultGirlAvatar;
                } else {
                    ele.src = defaultAvatar;
                }
            }
        },
    },
};
